<template>
  <!--换货列表-->
  <div class="main-wrap" id="ExchangeList">
    <div class="page-container">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" @click="handleSubmitReturnChange" :loading="isReturnLoading" class="h40">{{ $lang('提交退换货') }}</el-button>
        </el-form-item>
        <el-form-item v-if="exportStatus === 'already_print' || exportStatus === 'wait_print'">
          <print ref="printOrder" typeName="oneAndtwoLinkPage" :getPrintData="getPrintData" :options="printOptions" :hasPower="true" :isDisabled="!hasEdit"/>
        </el-form-item>
        <el-form-item v-if="exportStatus === 'already_print' || exportStatus === 'wait_print'">
          <el-button type="primary" @click="batchCancelOrder" :disabled="!hasEdit" icon="iconfont iconshanchu" class="h40">{{ $lang('批量取消') }}</el-button>
        </el-form-item>
        <el-form-item v-if="exportStatus === 'already_cancle'">
          <el-button type="primary" @click="batchDelOrder" :disabled="!hasEdit" icon="iconfont iconshanchu" class="h40">{{ $lang('批量删除') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="exportOpen" :loading="exportLoading" icon="iconfont icondaochu" class="h40" plain>{{ $lang('导出') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="isShowExportDownDialog = true" icon="iconfont icondaochu" class="h40" plain>{{ $lang('下载中心') }}</el-button>
        </el-form-item>
      </el-form>
      <el-form :model="searchParam" :inline="true" style="margin-top: 10px;">
        <el-form-item prop="date">
          <el-date-picker :clearable="false"
                          v-model="searchParam.date"
                          type="daterange"
                          :default-time="['00:00:00', '23:59:59']"
                          :range-separator="$lang('至')"
                          :start-placeholder="$lang('开始日期')"
                          :end-placeholder="$lang('结束日期')"
                          class="commonSize"
                          @change="selectDate"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :picker-options="datePickerOptions"/>
        </el-form-item>
        <el-form-item prop="ids">
          <base-input-tag style="width:220px"
                          v-model="searchParam.waybillIds"
                          :placeholder="$lang('请输入运单编号(最多可查100条)')"
                          :clearBtnVisible="true"
                          :addTagOnBlur="true"
                          ref="BaseInputTag1"
                          class="cms-input-tag"/>
        </el-form-item>
        <el-form-item prop="waybillNos">
          <base-input-tag style="width: 250px"
                          v-model="searchParam.originalWaybillIds"
                          :placeholder="$lang('请输入原始运单编号(最多可查100条)')"
                          :clearBtnVisible="true"
                          :addTagOnBlur="true"
                          ref="BaseInputTag"
                          class="cms-input-tag"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{ $lang('查询') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $lang('清空') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--菜单标签-->
    <div class="page-container table-bg">
      <div class="tab-nav">
        <div class="tab-nav-item"
             v-for="(item, index) in tabs" :key="index"
             @click="handleTabChange(index)"
             :class="{ active: tabActiveIndex === index }">
          {{ item.orderStatusName }}<span class="item-count">{{ item.total }}</span>
        </div>
      </div>
      <!--表格 -->
      <JmsTable ref="table"
                :data="tableList"
                :option="listOpt"
                :table-loading="loading"
                :page="page"
                :isCheckedAll="isCheckedAll"
                @size-change="sizeChange"
                @current-change="currentChange"
                @select-all="handleSelectAll"
                @select="handleSelectionChange">
        <template v-slot:orderStatusName="scope">
          <span class="dot" :class="{'oragin': scope.row.orderStatusName === '待打印'}" v-show="scope.row.orderStatusName === '待打印'">{{ $lang(scope.row.orderStatusName) }}</span>
          <span class="dot" :class="{'oragin': scope.row.orderStatusName === '已打印'}" v-show="scope.row.orderStatusName === '已打印'">{{ $lang(scope.row.orderStatusName) }}</span>
          <span class="dot" :class="{'green': scope.row.orderStatusName === '已取件'}" v-show="scope.row.orderStatusName === '已取件'">{{ $lang(scope.row.orderStatusName) }}</span>
          <span class="dot" v-show="scope.row.orderStatusName === '已取消'">{{ $lang(scope.row.orderStatusName) }}</span>
        </template>
        <template v-slot:waybillId="scope">
          <el-tooltip placement="top">
            <div slot="content" @click="handleCopy(scope)" style="cursor:pointer">{{ $lang('复制运单号') }}</div>
            <span @click="getExpressTracking(scope.row.waybillId)" class="getExpressTracking">{{ scope.row.waybillId }}</span>
          </el-tooltip>
        </template>
        <template v-slot:senderName="{row}">
          <div v-if="countryId === 1">
            <span>{{ row.senderName }}/</span>
            <span v-mask="{data: {...row,apiType:1},  key: 'senderMobilePhone', type: 'orderPlaintext'}"></span>
            <span>/{{row.senderProvinceName}}</span>
            <span>/{{row.senderCityName}}</span>
            <span>{{row.senderAreaName ? '/' + row.senderAreaName : ''}}</span>
            <span>{{row.senderStreet !== undefined && row.senderStreet !== null ? (row.senderStreet + '/') : ''}}</span>
            <span>{{row.senderShortAddress ? `${row.senderDetailedAddress}/` : row.senderDetailedAddress}}</span>
            <span>{{row.senderReferenceNumber ? `${row.senderShortAddress}/` : row.senderShortAddress}}</span>
            <span>{{row.senderBuildingNumber ? `${row.senderReferenceNumber}/` : row.senderReferenceNumber}}</span>
            <span>{{row.senderBuildingNumber}}</span>
          </div>
          <div v-else>
            <span>{{ row.senderName }}/</span>
            <span v-mask="{data: {...row,apiType:1},  key: 'senderMobilePhone', type: 'orderPlaintext' }"></span>
            <span>/{{row.senderProvinceName}}</span>
            <span>/{{row.senderCityName}}</span>
            <span>{{row.senderStreet !== undefined && row.senderStreet !== null ? (row.senderStreet + '/') : ''}}</span>
            <span>{{row.senderDetailedAddress}}</span>

          </div>
        </template>
        <template v-slot:receiverName="{row}">
          <div v-if="countryId === 1">
            <span>{{ row.receiverName }}/</span>
            <span v-mask="{data: {...row,apiType:2},  key: 'receiverMobilePhone', type: 'orderPlaintext' }"></span>
            <span v-if="row.receiverTelphone" v-mask="{data: {...row,apiType:2},  key: 'receiverTelphone', type: 'orderPlaintext' }">/</span>
            <span>/{{row.receiverProvinceName}}</span>
            <span>/{{row.receiverCityName}}</span>
            <span>{{row.receiverAreaName ? '/' + row.receiverAreaName : ''}}</span>
            <span>{{row.receiverStreet !== undefined && row.receiverStreet !== null ? (row.receiverStreet + '/') : ''}}</span>
            <span>{{row.receiverShortAddress ? `${row.receiverDetailedAddress}/` : row.receiverDetailedAddress}}</span>
            <span>{{row.receiverReferenceNumber ? `${row.receiverShortAddress}/` : row.receiverShortAddress}}</span>
            <span>{{row.receiverBuildingNumber ? `${row.receiverReferenceNumber}/` : row.receiverReferenceNumber}}</span>
            <span>{{row.receiverBuildingNumber}}</span>
          </div>
          <div v-else>
            <span>{{ row.receiverName }}/</span>
            <span v-mask="{data: {...row,apiType:2},  key: 'receiverMobilePhone', type: 'orderPlaintext' }"></span>
            <span v-if="row.receiverTelphone" v-mask="{data: {...row,apiType:2},  key: 'receiverTelphone', type: 'orderPlaintext' }">/</span>
            <span>/{{row.receiverProvinceName}}</span>
            <span>/{{row.receiverCityName}}</span>
            <span>{{row.receiverStreet !== undefined && row.receiverStreet !== null ? (row.receiverStreet + '/') : ''}}</span>
            <span>{{row.receiverDetailedAddress}}</span>
          </div>
        </template>
        <template v-slot:pic="scope">
          <el-button type="text" @click="handlePicList(scope.row)">{{ $lang('查看图片') }}</el-button>
        </template>
        <template v-slot:menu="scope">
          <!-- 行内查看详情按钮-->
          <el-button type="text" @click="handleRowView(scope.row)">{{ $lang('查看') }}</el-button>
          <!--行内编辑详情按钮-->
          <el-button
            type="text"
            @click="handleRowEdit(scope.row)"
            v-if="permission('EDIT', scope.row) && (scope.row.orderStatusName === '待打印' || scope.row.orderStatusName === '已打印')">
            {{ $lang('编辑') }}
          </el-button>
          <!--行内取消详情按钮-->
          <el-button
            type="text"
            @click="handleOrderCancel(scope.row)"
            v-if="permission('CANCEL', scope.row) && (scope.row.orderStatusName === '待打印' || scope.row.orderStatusName === '已打印')">
            {{ $lang('取消') }}
          </el-button>
        </template>
      </JmsTable>
    </div>

    <!--新建退换货-->
    <el-dialog :title="$lang('新建退换货')" width="900px" :close-on-click-modal="false" :visible.sync="isShowReturnsDialog">
      <div class="" style="text-align: center">
        <el-form :model="returnExchangeForm" ref="returnExchangeFormRule" :rules="returnExchangeFormRule" :inline="true" style="margin-top: 10px;">
          <el-form-item :label="$lang('单号')" prop="waybillNum" required>
            <el-input v-model="returnExchangeForm.waybillNum" :placeholder="$lang('请输入运单号')" maxlength="15" clearable/>
          </el-form-item>
          <el-form-item :label="$lang('退换货类型')" prop="returnExchangeType" required>
            <el-select v-model="returnExchangeForm.returnExchangeType" :placeholder="$lang('请选择')">
              <el-option :label="$lang('退货')" :value="1"></el-option>
              <el-option :label="$lang('退换货')" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button @click="isShowReturnsDialog = false" class="h40">{{ $lang('取消') }}</el-button>
        <el-button type="primary" @click="handleSubmitApply('returnExchangeFormRule')" class="h40">{{ $lang('提交申请') }}</el-button>
      </div>
    </el-dialog>
    <!--查看图片-->
    <el-dialog :title="$lang('查看图片')" width="900px" :close-on-click-modal="false" :visible.sync="isShowPicDialog">
      <div class="" style="text-align: center">
        <el-carousel trigger="click" height="150px">
          <el-carousel-item v-for="item in 4" :key="item">
            <h3 class="small">{{ item }}</h3>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
    <!--查看退换货详情信息-->
    <the-return-exchange-view v-if="isShowRowDataViewDialog" :dialogVisible.sync="isShowRowDataViewDialog" :rowData="rowData"/>
    <!--编辑退换货详情信息-->
    <the-return-exchange-edit :dialogVisible.sync="isShowRowDataEditDialog" :rowData="rowData" :type="2"/>
    <!--取消订单-->
    <the-cancel-order :dialogVisible.sync="isShowCancelOrderDialog" :selectId="selectId" @cancelSuccess="cancelSuccess"/>
    <!--导出订单弹框组件-->
    <base-export :cityOptions="orderOptions"
                 :exportVisible="exportVisible"
                 :idsLength="multipleSelection.length"
                 :exportData="exportData"
                 @export-close="exportVisible = false"
                 @export-fn="exportFn"/>
    <!--下载中心-->
    <export-download-dialog :moduleType="moduleType" :dialogExportDownVisible.sync="isShowExportDownDialog"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { commonFun } from '@/utils/common'
import { RESPONSE_SUCCESS, returnOrderList } from '@/constants'
import {
  fetchExchangeDetail,
  fetchExchangeExport,
  fetchReturnExchangeList,
  fetchExchangeTab,
  fetchExchangeWaybillStatus,
  orderBatchDelete,
  printOrders,
  fetchOneSingleMultiple
} from '@/api/module/customer'
import BaseExport from '@/components/base/BaseExport'
import ExportDownloadDialog from '@/components/export-download-dialog/ExportDownloadDialog'
import mixin from '@/mixins/mixin'
import JmsTable from '@/components/jms-widget/jms-table'
import TheReturnExchangeEdit from '@/views/return-exchange/components/TheReturnExchangeEdit'
import TheCancelOrder from '@/views/return-exchange/components/TheCancelOrder'
import Print from '@/components/jms-widget/print'
import BaseInputTag from '@/components/base/BaseInputTag'
import { UserDetail, orderPlaintext } from '@/api/base/public'
import TheReturnExchangeView from '@/views/return-exchange/components/TheReturnExchangeView'

export default {
  name: 'ExchangeList',
  components: { TheReturnExchangeView, BaseInputTag, Print, TheCancelOrder, TheReturnExchangeEdit, ExportDownloadDialog, BaseExport, JmsTable },
  mixins: [mixin],
  data() {
    return {
      COM_HTTP: {
        reqList: fetchReturnExchangeList,
        reqDetail: fetchExchangeDetail,
        reqExcel: fetchExchangeExport
      },
      // 退货单:1; 换货单:2
      returnType: 2,
      // 提交退换货表单
      returnExchangeForm: {
        waybillNum: '',		// 弹窗运单号
        returnExchangeType: '', // 退换货类型
      },
      returnExchangeFormRule: {
        waybillNum: { required: true, message: this.$lang('请输入运单号查询'), trigger: 'blur' },
        returnExchangeType: { required: true, message: this.$lang('请输入选择退换货类型'), trigger: 'blur' },
      },
      // 打印按钮配置
      printOptions: {
        btnTitle: this.$lang('面单打印'),
        btnType: 'primary',
        addClass: 'h40',
      },
      // 日期选择框配置
      datePickerOptions: {
        disabledDate: (time) => {
          const space = 90 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const maxTime = new Date(this.$taday.end).getTime()
          return time.getTime() < minTime || time.getTime() > maxTime
        }
      },
      isShowReturnsDialog: false, // 是否显示退换货弹窗
      isShowPicDialog: false,	// 图片弹窗
      isShowRowDataViewDialog: false, // 点击行内查看显示查看弹窗
      isShowRowDataEditDialog: false, // 点击行内编辑显示编辑弹窗
      isShowCancelOrderDialog: false, // 取消订单弹窗
      isShowExportDownDialog: false, // 下载中心对话框
      hasEdit: true, // 禁止按钮点击状态
      searchParam: {
        date: commonFun.GetTodayDate(),
        startDate: commonFun.GetTodayDate()[0],
        endDate: commonFun.GetTodayDate()[1],
        waybillIds: [], // 运单号
        originalWaybillIds: [], // 原始运单号
        tabTypeCode: 'wait_print',
        customerOrderIds: [], // 客户订单id
      },
      rowData: {},
      tabs: [], // tab标签栏
      tabActiveIndex: 1, // tab标签栏激活的索引
      multipleSelection: [], // 多选或全选数据
      isCheckedAll: false, // 是否选中所有
      isSingleSelection: [], // 单选
      selectId: [], // 取消订单选中的id
      exportVisible: false, // 导出弹框显示
      excelParams: {}, // 导出日期条件
      exportStatus: 'wait_print', // 默认状态
      exportType: 1, // 1：订单； 2：运单
      exportData: {}, // 导出数据
      exportLoading: false, // 导出按钮加载
      orderOptions: [], // 导出cityOptions配置选项
      moduleType: 'my_exchange-return_qy', // 下载中心
      isReturnLoading: false,
    }
  },
  async created() {
    const key = this.$route.params.typeNum
    this.updateOutExcel()
    await this.loadTabs()
    if (key) {
      this.handleSelect(key)
    } else {
      await this.searchFun()
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'viewAllData',
      'operationAllData'
    ]),
    countryId() {
      return this.$store.state.base.user.countryId || ''
    },
    listOpt() {
      return {
        border: true,
        selection: true,
        menuType: 'text',
        viewBtn: false,	// 查看
        editBtn: false,	// 编辑
        delBtn: false,	// 删除
        // rowKey: '$index',
        fixHeight: 90,
        menuWidth: 150,
        column: [
          {
            label: this.$lang('订单编号'),
            prop: 'id',
            width: 200
          },
          {
            label: this.$lang('原始运单号'),
            prop: 'originalWaybillId',
            width: 200,
            formatter: (row) => {
              return `${row.omsOrderThirdExtVO.originalWaybillId}`
            },
          },
          {
            label: this.$lang('运单编号'),
            prop: 'waybillId',
            width: 200,
            slot: true,
          },
          {
            label: this.$lang('状态'), //  运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
            prop: 'orderStatusName',
            slot: true,
          },
          {
            label: this.$lang('打印次数'),
            prop: 'printsNumber',
          },
          {
            label: this.$lang('客户订单号'),
            prop: 'customerOrderId',
            width: 150,
          },
          {
            label: this.$lang('寄件人地址'),
            prop: 'senderName',
            slot: true,
            width: 400,
            // formatter: (row) => {
            //   if (this.countryId === 1) {
            //     return `${row.senderName}/${row.senderMobilePhone}/${row.senderProvinceName}/${row.senderCityName}${row.senderAreaName ? '/' + row.senderAreaName : ''}/${row.senderStreet !== undefined && row.senderStreet !== null ? (row.senderStreet + '/') : ''}${row.senderDetailedAddress}`
            //   } else {
            //     return `${row.senderName}/${row.senderMobilePhone}/${row.senderProvinceName}/${row.senderCityName}/${row.senderStreet !== undefined && row.senderStreet !== null ? (row.senderStreet + '/') : ''}${row.senderDetailedAddress}`
            //   }
            // },
          },
          {
            label: this.$lang('收件方'),
            prop: 'receiverName',
            slot: true,
            width: 400,
            // formatter: (row) => {
            //   if (this.countryId === 1) {
            //     return `${row.receiverName}/${row.receiverMobilePhone}${row.receiverTelphone ? '/' + row.receiverTelphone : ''}/${row.receiverProvinceName}/${row.receiverCityName}${row.receiverAreaName ? '/' + row.receiverAreaName : ''}/${row.receiverStreet !== undefined && row.receiverStreet !== null ? (row.receiverStreet + '/') : ''}${row.receiverDetailedAddress}`
            //   } else {
            //     return `${row.receiverName}/${row.receiverMobilePhone}${row.receiverTelphone ? '/' + row.receiverTelphone : ''}/${row.receiverProvinceName}/${row.receiverCityName}/${row.receiverStreet !== undefined && row.receiverStreet !== null ? (row.receiverStreet + '/') : ''}${row.receiverDetailedAddress}`
            //   }
            // },
          },
          {
            label: this.$lang('是否调度'),
            prop: 'needDispatch',
            formatter: ({ needDispatch }) => {
              if (needDispatch === 1) {
                return this.$lang('是')
              } else if (needDispatch === 2) {
                return this.$lang('否')
              } else {
                return '--'
              }
            },
          },
          {
            label: this.$lang('件数'),
            prop: 'packageNumber',
            width: 80,
          },
          {
            label: this.$lang('物品类型'),
            prop: 'goodsTypeName',
            width: 100,
          },
          {
            label: this.$lang('物品名称'),
            prop: 'goodsName',
          },
          {
            label: this.$lang('物品重量'),
            prop: 'packageTotalWeight',
          },
          {
            label: this.$lang('产品类型'),
            prop: 'expressTypeName',
          },
          {
            label: this.$lang('结算方式'),
            prop: 'paymentModeName',
          },
          {
            label: this.$lang('支付方式'),
            prop: 'paidModeName',
          },
          {
            label: this.$lang('平台'),
            prop: 'platformName',
          },
          {
            label: this.$lang('客户账号'),
            prop: 'customerAccount',
          },
          {
            label: this.$lang('参考运费'),
            prop: 'standardValue',
            show: this.user.freightStatus === 1,
          },
          {
            label: this.$lang('订单来源'),
            prop: 'orderSourceName',
          },
          {
            label: this.$lang('下单账号'),
            prop: 'orderAccount',
          },
          {
            label: this.$lang('打印时间'),
            prop: 'printTime',
            width: 200,
          },
          {
            label: this.$lang('取消原因'),
            prop: 'cancelReason',
          },
        ],
      }
    }
  },
  watch: {
    tableList: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.isKeyUp && this.exportStatus === 'wait_print' && this.tableList.length === 1 && this.autoPrint) {
          this.autoPrint = false
          this.multipleSelection = this.tableList
          this.$nextTick(() => {
            this.$refs.table.$refs.table.toggleRowSelection(this.tableList[0], true)
            this.$refs.printOrder && this.$refs.printOrder.openMenu()
          })
        }
      },
    },
    multipleSelection: {
      deep: true,
      immediate: true,
      handler(arr) {
        console.log('选择--------->>', arr)
        if (arr && arr.length) {
          this.hasEdit = arr.every(row => {
            return this.permission('CANCEL', row)
          })
        } else {
          this.hasEdit = false
        }
      }
    },
  },
  methods: {
    ...mapActions(['SET_USER', 'UPDATE_PRINT_STOCK']),
    /**
     * 重写方法获取参数
     * @returns {{}}
     */
    getParams() {
      const { startDate, endDate, waybillIds, originalWaybillIds, tabTypeCode } = this.searchParam
      return {
        pageSize: this.page.size,
        startdate: waybillIds.length ? '' : startDate,
        enddate: waybillIds.length ? '' : endDate,
        waybillIds: waybillIds, // 运单号
        originalWaybillIds: originalWaybillIds, // 原始运单编号
        tabTypeCode: tabTypeCode, // 运单状态
        returnType: this.returnType,
        needOrderExt: true,
        isVip: true
      }
    },
    /**
     * 查询
     * @param params
     */
    async searchChange(params) {
      try {
        const { waybillIds, originalWaybillIds } = this.searchParam
        const space = 31 * 24 * 3600 * 1000
        const startDate = new Date(this.searchParam.startDate).getTime()
        const endDate = new Date(this.searchParam.endDate).getTime()
        if ((endDate - startDate) > space) {
          return this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
        }
        this.searchParam.tabTypeCode = this.tabs.length > 0 ? this.tabs[this.tabActiveIndex].orderStatusCode : ''

        // 处理运单编号
        if (waybillIds && waybillIds.length !== 0) {
          if (waybillIds.length > 100) {
            return this.$message.warning(this.$lang('请勿超过100条运单'))
          }
        }
        // 处理运单编号
        if (originalWaybillIds && originalWaybillIds.length !== 0) {
          if (originalWaybillIds.length > 100) {
            return this.$message.warning(this.$lang('请勿超过100条运单'))
          }
        }
        // 列表查询
        await this.searchFun(1)
        await this.loadTabs()
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * 获取tabs标签
     * @returns {Promise<void>}
     */
    async loadTabs() {
      const { startDate, endDate, waybillIds, originalWaybillIds } = this.searchParam
      const params = {
        startdate: waybillIds.length ? '' : startDate,
        enddate: waybillIds.length ? '' : endDate,
        waybillIds: waybillIds, // 运单号
        originalWaybillIds: originalWaybillIds, // 收件人手机号
        returnType: this.returnType,
      }
      console.log('params', params)
      // 运单状态数据统计
      const { code, data, msg } = await fetchExchangeTab(params)
      if (code === RESPONSE_SUCCESS) {
        this.tabs = data
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 处理tab切换
     * @param val
     */
    handleTabChange(val) {
      this.tabActiveIndex = val
      this.handleSelect(val)
    },
    /**
     * 快捷菜单搜索
     * @param key
     */
    handleSelect(key) {
      const { orderStatusCode } = this.tabs[key]
      this.searchParam.tabTypeCode = orderStatusCode
      this.exportStatus = orderStatusCode
      this.tabActiveIndex = key
      this.currentKey = parseInt(key)
      this.page.current = 1
      this.searchFun()
      this.loadTabs()
    },
    /**
     * 权限
     * @param type
     * @param row
     */
    permission(type, row) {
      const { isSelf } = row
      const { operationAllData } = this
      const isMasterAcc = this.user.parentId === 0
      if (type === 'EDIT') {
        return isSelf
      } else if (type === 'CANCEL') {
        return isMasterAcc || (!isMasterAcc && (operationAllData || isSelf))
      }
    },
    /**
     * 方法重写
     * 处理选中所有
     * @param val
     */
    handleSelectAll(val) {
      const newArr = val.filter(item => {
        return this.permission('CANCEL', item)
      })
      console.log('全选----before', val)
      console.log('全选----after', newArr)
      this.multipleSelection = newArr
      this.originSelectionAll = [...newArr]
      this.isCheckedAll = newArr.length > 0
    },
    /**
     * 方法重写
     * 单个选中
     * @param val
     * @param currentRow
     */
    handleSelectionChange(val, currentRow) {
      // 检测当前行的选中状态
      const isChecked = val.some(item => item.id === currentRow.id)
      if (this.isCheckedAll) {
        if (!isChecked) {
          this.isSingleSelection = [...(this.isSingleSelection || []), currentRow.id]
        } else {
          this.isSingleSelection = this.isSingleSelection.filter(item => item !== currentRow.id)
        }
        this.multipleSelection = this.originSelectionAll.filter(item => !this.isSingleSelection.includes(item.id))
      } else {
        this.multipleSelection = val
      }
    },
    /**
     * 方法重写
     * 选择分页条数
     * @param val
     * @param list
     */
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    /**
     * 方法重写
     * 跳转页码
     * @param val
     */
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    /**
     * 批量取消订单
     */
    batchCancelOrder() {
      const ids = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusName === '待打印' || item.orderStatusName === '已打印') {
          ids.push(item.omsOrderThirdExtVO.orderId)
        }
      })
      if (ids.length <= 0) {
        this.$message.warning(this.$lang('没有可取消的订单'))
        return
      }
      this.selectId = ids
      this.isShowCancelOrderDialog = true
    },
    /**
     * 处理订单取消
     * @param row
     */
    handleOrderCancel(row) {
      this.selectId = [row.omsOrderThirdExtVO.orderId]
      this.isShowCancelOrderDialog = true
    },
    /**
     * 取消订单成功回调
     */
    cancelSuccess() {
      this.multipleSelection = []
      this.loadTabs()
      this.searchFun()
    },
    /**
     * 查看订单
     * @param row
     */
    handleRowView(row) {
      this.rowData = row
      this.isShowRowDataViewDialog = true
    },
    /**
     * 处理订单编辑
     * @param row
     */
    async handleRowEdit(row) {
      this.loading = true
      const { code, data, msg } = await fetchExchangeDetail({
        from: 'vip',
        id: row.id,
        // 1:订单号; 2:运单号
        idType: 1,
        needOrderMember: true,
        needOrderExt: true
      })
      if (code === RESPONSE_SUCCESS) {
        this.rowData = data
        const res = await orderPlaintext({ id: data.id, waybillNo: data.waybillId, type: 1 })
        if (res.code === RESPONSE_SUCCESS) {
          this.rowData = { ...this.rowData, ...res.data }
        }
        const resReceiving = await orderPlaintext({ id: data.id, waybillNo: data.waybillId, type: 2 })
        if (resReceiving.code === RESPONSE_SUCCESS) {
          this.rowData = { ...this.rowData, ...resReceiving.data }
        }
        this.isShowRowDataEditDialog = true
      } else {
        this.$message.error(msg)
      }
      this.loading = false
    },
    /**
     * 删除订单
     * @returns {Promise<ElMessageComponent>}
     */
    async batchDelOrder() {
      const ids = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusName === '已取消') {
          ids.push(item.id)
        }
      })
      if (ids.length <= 0) {
        return this.$message.warning(this.$lang('没有可取消的订单'))
      }
      this.$confirm(
        `<div class="comfirm-wrap">
                    <i class="el-icon-warning"></i>
                    <h3 class="comfirm-hd">${this.$lang('删除订单')}</h3>
                  </div>
                  <p class="comfirm-tit">${this.$lang('你确定要删除已选中的订单吗？')}</p>`,
        '',
        {
          confirmButtonText: this.$lang('确定'),
          cancelButtonText: this.$lang('取消'),
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          customClass: 'comfirm-box',
        }).then(async () => {
        this.loading = true
        const { code, msg } = await orderBatchDelete(ids)
        this.loading = false
        if (code === RESPONSE_SUCCESS) {
          this.$message.success(this.$lang('删除成功'))
          this.searchChange()
        } else {
          this.$message.error(this.$lang(msg))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * 选择日期
     */
    selectDate() {
      if (!this.searchParam.date) {
        return
      }
      const [start = '', end = ''] = this.searchParam.date
      this.searchParam.startDate = start
      this.searchParam.endDate = end
    },
    /**
     * 重置搜索
     */
    resetSearch() {
      this.searchParam = {
        date: commonFun.GetTodayDate(),
        startDate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        endDate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        waybillIds: [],
        originalWaybillIds: []
      }
      this.$refs.BaseInputTag.clearFn()
    },
    /**
     * 提交退换货申请
     * @returns {Promise<void>}
     */
    async handleSubmitApply(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const { code, msg } = await fetchExchangeWaybillStatus({ waybillNo: this.returnExchangeForm.waybillNum })
          if (code === RESPONSE_SUCCESS) {
            this.isShowReturnsDialog = false
            this.$router.push({
              path: `/submitReturns/${this.returnExchangeForm.waybillNum}/${this.returnExchangeForm.returnExchangeType}`,
            })
          } else {
            this.isShowReturnsDialog = false
            this.$message.error(msg)
          }
        }
      })
    },
    /**
     * 打开导出弹框
     */
    async exportOpen() {
      // 处理订单编号
      const { waybillIds, originalWaybillIds } = this.searchParam
      // 处理客户订单号
      if (originalWaybillIds && originalWaybillIds.length !== 0) {
        if (originalWaybillIds.length > 500) {
          return this.$message.warning(this.$lang('请勿超过500条客户订单号'))
        }
      }
      // 处理运单编号
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }

      if (this.multipleSelection.length <= 0) {
        this.exportLoading = true
        await this.loadTabs()
        await this.searchFun()
        this.exportLoading = false
        const listTotal = this.tabs[this.tabActiveIndex].total || 0
        if (listTotal <= 0) {
          return this.$message.warning(this.$lang('没有可导出的数据'))
        }
        if (listTotal > 100000) {
          return this.$message.warning(this.$lang('导出数量超过限制'))
        }
      }
      this.orderOptions = [...returnOrderList]
      // 如果设置了 不显示参考运费 删除参考运费
      if (this.user.freightStatus === 0) {
        const chooseIndex = this.orderOptions.findIndex(item => item.name === '参考运费')
        // 删除参考运费选项
        this.orderOptions.splice(chooseIndex, 1)
      }

      this.updateOutExcel(this.currentKey)
      this.exportVisible = true
      this.exportData = {
        exportStatus: this.exportStatus,
        exportType: this.exportType, // 1：订单； 2：运单
      }
    },
    /**
     * 更新导出参数配置
     */
    updateOutExcel() {
      const inputTime = {
        key: 'inputTime',
        name: this.$lang('下单时间'),
      }
      const pickTime = {
        key: 'pickTime',
        name: this.$lang('取件时间'),
      }
      const cancelTime = {
        key: 'cancelTime',
        name: this.$lang('取消时间'),
      }
      this.orderOptions.push(inputTime, pickTime, cancelTime)
    },
    /**
     * 导出数据
     * @param status
     * @param data
     * @param dataParams
     * @returns {Promise<void>}
     */
    async exportFn(status, data, dataParams) {
      console.log(data)
      this.exportVisible = status
      this.columnList = data
      this.excelParams = dataParams
      // 改为异步导出
      const param = this.getParamForOutExcel()
      // 调用导出api
      const { code, msg } = await this.COM_HTTP.reqExcel(param)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('导出成功，请到下载中心查看'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    /**
     * 导出-获取参数
     * @returns
     */
    getParamForOutExcel() {
      const sort = []
      const columnNames = []
      let ids = []
      const len = this.multipleSelection && this.multipleSelection.length || 0
      if (len) ids = this.multipleSelection.map(item => item.id)
      // 处理导出表格的属性字段
      this.columnList.forEach(item => {
        sort.push(item.key)
        columnNames.push(item.name)
      })
      let params = { sort, columnNames, orderStatusCode: this.exportStatus, tabTypeCode: this.exportStatus, isVip: true }
      if (len) params = { ...params, ids }
      else {
        params = { ...params, ...this.searchParam }
      }
      const arr = ['current', 'size', 'startdate', 'enddate', 'date', 'tabTypeCode', 'columnNames', 'sort', 'orderStatusCode', 'isVip']
      Object.keys(params).forEach(item => {
        if (!arr.includes(item)) {
          if (params[item] instanceof Array && params[item][0]) {
            delete params.startdate
            delete params.enddate
          } else if (typeof params[item] === 'string' && params[item]) {
            delete params.startdate
            delete params.enddate
          }
        }
      })
      console.log(params)
      return params
    },
    /**
     * 查看图片
     * @param index
     */
    handlePicList(index) {
      this.isShowPicDialog = true
    },
    /**
     * 获取运单轨迹
     * @param waybillId
     */
    getExpressTracking(waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    },
    /**
     * copy运单号
     * @param data
     */
    handleCopy(data) {
      const value = data.row.waybillId
      const oInput = document.createElement('input')
      oInput.value = value
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: this.$lang('运单号复制成功'),
        type: 'success',
      })
      oInput.remove()
    },
    /**
     * 获取打印数据
     * @param type
     * @param language
     * @returns {Promise<boolean|*>}
     */
    async getPrintData(type, language) {
      const obj = this.multipleSelection.find(item => item.paymentModeName === '到付现结' && (!item.standardValue || item.standardValue === 0 || item.standardValue === '0'))
      if (obj) {
        this.$nextTick(() => {
          this.$message.warning(this.$lang('存在到付快件未维护费用，请联系网点维护'))
          this.multipleSelection = []
          this.isCheckedAll = false
          this.searchChange()
        })
        this.$refs['printOrder'].keyBtn = false
        return false
      }
      const newArr = this.multipleSelection.map((item, index, selection) => {
        return {
          id: item.id,
          orderSourceName: item.orderSourceName
        }
      })
      const params = { orders: newArr, printType: type, isVip: true, language } // 添加language
      const res = await printOrders(params)
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
        // settlementName 到付现结 freight
        this.isCheckedAll = false
        setTimeout(() => {
          this.searchChange()
          // 更新库存面单
          if (this.exportStatus !== 'already_print') {
            this.UPDATE_PRINT_STOCK(true)
          }
        }, 1100)
        return res.data
      } else {
        this.$refs['printOrder'].keyBtn = false
        res.msg && this.$message.error(this.$lang(res.msg))
        return false
      }
    },
    /**
     * 更新面单库存(获取用户信息)
     * @returns {Promise<void>}
     */
    async getUserInfo() {
      const { code, data, msg } = await UserDetail({ id: this.user.id })
      if (code === RESPONSE_SUCCESS) {
        this.SET_USER({ ...this.user, ...data }) // 更新vuex的用户数据
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 提交退换货
     * @returns {Promise<void>}
     */
    async handleSubmitReturnChange() {
      this.isReturnLoading = true
      const { code, msg } = await fetchOneSingleMultiple({})
      this.isReturnLoading = false
      if (code === RESPONSE_SUCCESS) {
        this.isShowReturnsDialog = true
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#ExchangeList {
  .page-container {
    padding: 16px 24px;
  }

  .tab-nav {
    .tab-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 16px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;

      &:first-of-type {
        margin-left: 0;
      }

      &.active {
        background: #fff;
        color: #e60012;

        i {
          color: #e60012;
        }
      }
    }

    .item-count {
      display: inline-block;
      width: 28px;
      height: 16px;
      font-size: 10px;
      line-height: 16px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }

  .table-bg {
    background: #edeef3;
  }
}
</style>
